module.exports = __webpack_public_path__ + "img/default-uid.0b1068d.png";